// extracted by mini-css-extract-plugin
export default {"errorText":"style_errorText__qh7Mn","sidepanelContentWrapper":"style_sidepanelContentWrapper__rCR6X"};